/**
 * @file: 活动页面的action
 * @author: wence
 */
import {rcAjax} from '../util';

import qs from 'query-string';
// 获取活动奖品信息
export const fetchActivityInfo = params => rcAjax(
    'POST',
    '/xiapi/api/v1/activity/getActivity',
    {},
    params,
    () => null
).then(data => data && data.data || {});

// 获取剩余中奖次数
export const fetchRemain = params => rcAjax(
    'POST',
    '/xiapi/api/v1/activity/remain',
    {},
    params,
    () => null
).then(data => data && data.data || {});

export const fetchPrize = params => rcAjax(
    'POST',
    '/xiapi/api/v1/activity/prize',
    {},
    qs.stringify(params),
    () => null,
).then(data => data && data.data || {});

// 获取中奖信息
export const fetchPrizeInfo = params => rcAjax(
    'POST',
    '/xiapi/api/v1/activity/getPrizeInfo',
    {},
    params,
    () => null
).then(data => data && data.data || {});

// 添加实物地址
export const updateContact = params => rcAjax(
    'POST',
    '/xiapi/api/v1/activity/contact',
    {},
    params,
    () => null
).then(data => data && data.data || {});



// WEBPACK FOOTER //
// ./src/actions/activityAction.js